import { Component, OnInit, Input, ViewChild, SimpleChanges } from '@angular/core';
import { ProfileService } from '../shared/profile.service';
import { ProfileAvatarInfoDto } from '../shared/dto/profile-avatar-info.dto';

@Component({
  selector: 'wl-profile-type-icon-report-name',
  templateUrl: 'profile-type-icon-report-name.component.html',
  standalone: false
})
export class ProfileTypeIconReportNameComponent implements OnInit {
  @Input() public profileId: number = 0;
  avatarInfo: ProfileAvatarInfoDto;
  isLoading: boolean = true;

  public constructor(private _profileService: ProfileService) {}

  ngOnInit() {
    if (this.profileId > 0) {
      this._profileService.getProfileAvatarInfo(this.profileId).then((data) => {
        this.avatarInfo = data;
        this.isLoading = false;
      });
    }
  }
}
